
import respUtility from '@/mixins/respUtility';

export default {
  name: 'ProductInfoGallerySlidersPopup',
  mixins: [respUtility],
  props: {
    mainGallery: {
      type: Array,
      default() {
        return [];
      },
    },
    thumbGallery: {
      type: Array,
      default() {
        return [];
      },
    },
    customerMainGallery: {
      type: Array,
      default() {
        return [];
      },
    },
    customerThumbGallery: {
      type: Array,
      default() {
        return [];
      },
    },
    view3D: {
      type: Object,
      default() {
        return {};
      },
    },
    showPopup: {
      type: Boolean,
      default: false,
    },
    indexTabPopup: {
      type: Number,
    },
    indexSliderPopup: {
      type: Number,
    },
  },
  data() {
    return {
      setShowPopup: this.showPopup,
      tab: this.indexTabPopup || 0,
      tabs: [
        {
          tabName: 'Product Images',
          title: 'Product Images',
          value: 'productImages',
        },
        {
          tabName: 'Customer Images',
          title: 'Customer Images',
          value: 'customerImages',
        },
      ],
    };
  },
  computed: {
    currentTab() {
      return this.tabs[this.tab] || this.tabs[0];
    },
    galleriesCount() {
      if (this.customerMainGallery?.length) {
        return 2;
      }
      return 1;
    },
    isBoutiquePage() {
      return this.$store.state.metaData?.addons?.head?.isBoutique || false;
    },
    vDialogContentClasses() {
      const classes = [
        this.$style.galleryPopup,
      ];

      if (this.$attrs.isCompare) {
        classes.push(this.$style.gallerySmallPopup);
      }

      return classes;
    },
  },
  methods: {
    setTab(tab) {
      this.tab = tab;
      this.$emit('change-index-slider-popup', 0);
    },
    closePopup() {
      this.$emit('close-popup');
    },
  },
};
